import React from 'react';
import Icon from '../../../components/AppIcon';

const ProgressIndicator = ({ currentStep, totalSteps, completedFields, totalFields }) => {
  const progressPercentage = Math.round((completedFields / totalFields) * 100);
  
  const getStepStatus = (stepIndex) => {
    if (stepIndex < currentStep) return 'completed';
    if (stepIndex === currentStep) return 'current';
    return 'pending';
  };

  const steps = [
    {
      id: 1,
      title: 'ข้อมูลผู้ยื่นเรื่อง',
      description: 'กรอกชื่อและข้อมูลติดต่อ'
    },
    {
      id: 2,
      title: 'รายละเอียดเรื่องร้องเรียน',
      description: 'เลือกหมวดหมู่และอธิบายปัญหา'
    },
    {
      id: 3,
      title: 'ตรวจสอบและส่ง',
      description: 'ตรวจสอบข้อมูลและยืนยันการส่ง'
    }
  ];

  return (
    <div className="bg-card rounded-lg border border-border shadow-government p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-foreground">
          ความคืบหน้า
        </h3>
        <div className="text-sm text-muted-foreground">
          {completedFields}/{totalFields} ฟิลด์
        </div>
      </div>
      {/* Progress Bar */}
      <div className="mb-6">
        <div className="flex justify-between items-center mb-2">
          <span className="text-sm text-muted-foreground">
            ความสมบูรณ์
          </span>
          <span className="text-sm font-medium text-primary">
            {progressPercentage}%
          </span>
        </div>
        <div className="w-full bg-muted rounded-full h-2">
          <div 
            className="bg-primary rounded-full h-2 transition-all duration-300"
            style={{ width: `${progressPercentage}%` }}
          />
        </div>
      </div>
      {/* Step Indicators */}
      <div className="space-y-4">
        {steps?.map((step, index) => {
          const status = getStepStatus(index);
          
          return (
            <div key={step?.id} className="flex items-start space-x-3">
              <div className={`
                w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0
                transition-government
                ${status === 'completed' 
                  ? 'bg-success text-white' 
                  : status === 'current' ?'bg-primary text-white' :'bg-muted text-muted-foreground'
                }
              `}>
                {status === 'completed' ? (
                  <Icon name="Check" size={16} />
                ) : (
                  <span className="text-sm font-medium">{step?.id}</span>
                )}
              </div>
              <div className="flex-1">
                <h4 className={`
                  font-medium text-sm
                  ${status === 'current' ?'text-primary' 
                    : status === 'completed' ?'text-success' :'text-muted-foreground'
                  }
                `}>
                  {step?.title}
                </h4>
                <p className="text-xs text-muted-foreground mt-1">
                  {step?.description}
                </p>
              </div>
            </div>
          );
        })}
      </div>
      {/* Required Fields Reminder */}
      {completedFields < totalFields && (
        <div className="mt-6 p-4 bg-warning/10 border border-warning/20 rounded-lg">
          <div className="flex items-start space-x-3">
            <Icon name="AlertCircle" size={16} className="text-warning flex-shrink-0 mt-0.5" />
            <div className="flex-1">
              <p className="text-sm font-medium text-warning-foreground">
                ฟิลด์ที่จำเป็น
              </p>
              <p className="text-xs text-muted-foreground mt-1">
                กรุณากรอกข้อมูลในฟิลด์ที่มีเครื่องหมาย * ให้ครบถ้วน
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProgressIndicator;